export class Message {
    constructor(sender, msgType, payload, originator, version, topic, destination) {
        this.sender = sender;
        this.msgType = msgType;
        this.payload = payload;
        this.originator = originator;
        this.version = version;
        this.topic = topic;
        this.destination = destination;
    }
}
//# sourceMappingURL=message.js.map